import * as React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import moment from "moment";

const contentHeaderSX = {
  fontSize: "1rem",
  marginBottom: '0.5rem',
  color: "#fff",
  fontWeight: 600,
  letterSpacing: '1px',
  textDecoration: 'underline',
  textAlign: {
    xl: "left",
    lg: "left",
    md: "left",
    sm: "center",
    xs: "center",
  },
}

const contentParaSX = {
  fontSize: "1rem",
  color: "#fff",
  cursor: "pointer",
  "&:Hover": {
    color: "#F9FAFB",
  },
  textAlign: {
    xl: "left",
    lg: "left",
    md: "left",
    sm: "center",
    xs: "center",
  },
}

const sectionSX = {
  maxWidth: {
    xl: "12rem",
    lg: "12rem",
    md: "12rem",
    sm: "100%",
    xs: "100%",
  },
  display: "flex",
  flexDirection: "column",
  rowGap: ".55rem",
  flex: "1",
  alignItems: {
    xl: "start",
    lg: "start",
    md: "start",
    sm: "center",
    xs: "center",
  },
}

export default function Footer() {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <script src="https://images.dmca.com/Badges/DMCABadgeHelper.min.js"> </script>
      </Helmet>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#412C6C",
          p: {
            xl: "2rem 2.5rem",
            lg: "2rem 2.5rem",
            md: "2rem 2.5rem",
            sm: "2rem 2rem",
            xs: "2rem 2rem",
          },
          rowGap: {
            xl: "3.5rem",
            lg: "3.5rem",
            md: "3.5rem",
            sm: "2rem",
            xs: "2rem",
          },
          boxShadow: "0px 6px 18px -8px rgba(58, 53, 65, 0.56)",
          pt: "2rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xl: "row",
              lg: "row",
              md: "row",
              sm: "column",
              xs: "column",
            },
            justifyContent: "space-between",
            rowGap: "1.5rem",
          }}
        >
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: "3.6",
            h5: {
              fontWeight: 700,
              lineHeight: 1.125,
              color: "#fff",
              textAlign: {
                xl: "left",
                lg: "left",
                md: "left",
                sm: "center",
                xs: "center",
              },
            }
          }}>
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xl: "2.5rem",
                  lg: "2.5rem",
                  md: "2.5rem",
                  sm: "1.8rem",
                  xs: "1.8rem",
                },
              }}
            >
              Acadlance
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xl: "0.875rem",
                  lg: "0.875rem",
                  md: "0.875rem",
                  sm: "0.75rem",
                  xs: "0.75rem",
                },
                letterSpacing: '1.5px'
              }}
            >
              Pioneering Solution
            </Typography>
          </Box>
          <Box sx={sectionSX}>
            <Typography
              variant="p"
              sx={{
                ...contentHeaderSX,
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate("/find-an-expert");
              }}
            >
              Find An Expert
            </Typography>

            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/find-an-expert/Nursing");
              }}
            >
              Nursing
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/find-an-expert/Law");
              }}
            >
              Law
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/find-an-expert/Accounting");
              }}
            >
              Accounting
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/find-an-expert/Finance");
              }}
            >
              Finance
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/find-an-expert/Management");
              }}
            >
              Management
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/find-an-expert");
              }}
            >
              View All
            </Typography>
          </Box>
          <Box sx={sectionSX}>
            <Typography
              variant="p"
              sx={{
                ...contentHeaderSX,
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate("/find-a-task");
              }}
            >
              Find A Task
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/find-a-task");
              }}
            >
              View All
            </Typography>

            <Typography
              variant="p"
              sx={{
                ...contentHeaderSX,
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate("/post-a-task");
              }}
            >
              Post A Task
            </Typography>

            <Typography
              variant="p"
              sx={contentHeaderSX}
            >
              Resources
            </Typography>
            
            <Typography
              variant="p"
              sx={{
                ...contentHeaderSX,
                cursor: 'pointer',
              }}
              onClick={() => {
                navigate("/client-expert/academic-certification");
              }}
            >
              Certification Test
            </Typography>

            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/blogs");
              }}
            >
              Blogs
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/talent-nest");
              }}
            >
              Find Talent
            </Typography>

          </Box>
          <Box
            sx={{
              ...sectionSX,
              maxWidth: {
                xl: "10rem",
                lg: "10rem",
                md: "10rem",
                sm: "100%",
                xs: "100%",
              },
            }}
          >
            <Typography
              variant="p"
              sx={contentHeaderSX}
            >
              Company
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/about-us");
              }}
            >
              About Us
            </Typography>

            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/contact-us");
              }}
            >
              Contact Us
            </Typography>

            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/pricing");
              }}
            >
              Pricing
            </Typography>

            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/terms");
              }}
            >
              Terms & Conditions
            </Typography>

            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/privacy-policy");
              }}
            >
              Privacy Policy
            </Typography>
            
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/refund-policy");
              }}
            >
              Refund & Cancellation
            </Typography>
            <Typography
              variant="p"
              sx={contentParaSX}
              onClick={() => {
                navigate("/reported-scams");
              }}
            >
              Report Scam
            </Typography>
          </Box>
        </Box>

        <Box sx={{
          width: '100%',
          minHeight: '1px',
          backgroundColor: '#DFE3E8',
          margin: 'auto',
          borderRadius: '0.25rem'
        }}></Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xl: "row",
              lg: "row",
              md: "row",
              sm: "column",
              xs: "column",
            },
            justifyContent: "space-between",
            rowGap: "1rem",
            marginTop: {
              xl: '-2.5rem',
              lg: '-2.5rem',
              md: '-2.5rem',
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                xl: "row",
                lg: "row",
                md: "row",
                sm: "column",
                xs: "column",
              },
              rowGap: ".75rem",
              columnGap: ".75rem",
              alignItems: {
                xl: "left",
                lg: "left",
                md: "left",
                sm: "center",
                xs: "center",
              },
              flex: { xl: "3.6", lg: "3.6", md: "3.6", sm: "1", xs: "1" },
            }}
          >
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  columnGap: ".75rem",
                  color: '#FFFFFF',
                  alignItems: 'start',
                  justifyContent: {
                    xl: 'flex-start',
                    lg: 'flex-start',
                    md: 'flex-start',
                    sm: 'center',
                    xs: 'center'
                  }
                }}
              >
                Follow us
                <a href="https://www.linkedin.com/company/acadlance?trk=public_post_feed-actor-name" target="_blank" aria-label="Acadlance LinkedIn Profile "><Linkedin /></a>
                <a href="https://www.facebook.com/people/Acadlance-Academic-Writing-Marketplace/61560664434820" target="_blank" aria-label="Acadlance Facebook Profile "><Facebook /></a>
                <a href="https://www.instagram.com/acadlance" target="_blank" aria-label="Acadlance Instagram Profile "><Instagram /></a>
              </Box>
              <Typography
                variant="h5"
                style={{
                  marginTop: '0.5rem',
                  fontSize: ".85rem",
                  fontFamily: "Roboto",
                  color: "#fff",
                  flex: "1",
                }}
              >
                Contact us : enquiries@acadlance.com
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                columnGap: ".75rem",
                color: '#FFFFFF',
                marginTop: '0.5rem',
                alignItems: 'start',
                justifyContent: {
                  xl: 'flex-end',
                  lg: 'flex-end',
                  md: 'flex-end',
                  sm: 'center',
                  xs: 'center'
                }
              }}
            >
              <a href="//www.dmca.com/Protection/Status.aspx?ID=9688993e-668e-4c2b-9bdc-7e2bc154c442" title="DMCA.com Protection Status" className="dmca-badge"> <img src="https://images.dmca.com/Badges/_dmca_premi_badge_4.png?ID=9688993e-668e-4c2b-9bdc-7e2bc154c442" alt="DMCA.com Protection Status" /></a>
            </Box>
            <Typography
              variant="h5"
              sx={{
                marginTop: '0.5rem',
                fontSize: {
                  xl: ".85rem",
                  lg: ".85rem",
                  md: ".85rem",
                  sm: ".85rem",
                  xs: ".85rem",
                },
                fontFamily: "Roboto",
                color: "#fff",
                display: "flex",
                justifyContent: {
                  xl: "flex-end",
                  lg: "flex-end",
                  md: "flex-end",
                  sm: "center",
                  xs: "center",
                },
              }}
            >
              Copyright © {moment().year()} Acadlance
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xl: ".85rem",
                  lg: ".85rem",
                  md: ".85rem",
                  sm: ".85rem",
                  xs: ".85rem",
                },
                fontFamily: "Roboto",
                color: "#fff",
                display: "flex",
                textAlign: 'center',
                justifyContent: {
                  xl: "flex-end",
                  lg: "flex-end",
                  md: "flex-end",
                  sm: "center",
                  xs: "center",
                },
              }}
            >
              Acadlance operates as a proprietary firm under the leadership of Budhesh Chopra
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xl: ".85rem",
                  lg: ".85rem",
                  md: ".85rem",
                  sm: ".85rem",
                  xs: ".85rem",
                },
                fontFamily: "Roboto",
                color: "#fff",
                display: "flex",
                textAlign: 'center',
                justifyContent: {
                  xl: "flex-end",
                  lg: "flex-end",
                  md: "flex-end",
                  sm: "center",
                  xs: "center",
                },
              }}
            >
             Panchsheel Pratishtha Tower-1, Sector-75, Noida, Gautam buddha Nagar, UP, 201301
             {/* 3rd Floor Unit No. 302, Plot No. 16 Panchsheel Pratishtha Tower-1<br />
             Sector-75, Noida, Gautam buddha Nagar, UP, 201301 */}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}

// const Twitter = ({ size = 20, fill = "#fff" }) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={size}
//     height={size}
//     viewBox="0 0 24 24"
//     fill={fill}
//   >
//     <path d="M24 4.37a9.6 9.6 0 0 1-2.83.8 5.04 5.04 0 0 0 2.17-2.8c-.95.58-2 1-3.13 1.22A4.86 4.86 0 0 0 16.61 2a4.99 4.99 0 0 0-4.79 6.2A13.87 13.87 0 0 1 1.67 2.92 5.12 5.12 0 0 0 3.2 9.67a4.82 4.82 0 0 1-2.23-.64v.07c0 2.44 1.7 4.48 3.95 4.95a4.84 4.84 0 0 1-2.22.08c.63 2.01 2.45 3.47 4.6 3.51A9.72 9.72 0 0 1 0 19.74 13.68 13.68 0 0 0 7.55 22c9.06 0 14-7.7 14-14.37v-.65c.96-.71 1.79-1.6 2.45-2.61z" />
//   </svg>
// );

const Facebook = ({ size = 20, fill = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
  >
    <path d="M24 12.07C24 5.41 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.5h-2.8V24C19.62 23.1 24 18.1 24 12.07" />
  </svg>
);

const Instagram = ({ size = 20, fill = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill={fill}
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier">
      <defs></defs>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Dribbble-Light-Preview" transform="translate(-340.000000, -7439.000000)" fill={fill}>
          <g id="icons" transform="translate(56.000000, 160.000000)">
            <path
              d="M289.869652,7279.12273 C288.241769,7279.19618 286.830805,7279.5942 285.691486,7280.72871 C284.548187,7281.86918 284.155147,7283.28558 284.081514,7284.89653 C284.035742,7285.90201 283.768077,7293.49818 284.544207,7295.49028 C285.067597,7296.83422 286.098457,7297.86749 287.454694,7298.39256 C288.087538,7298.63872 288.809936,7298.80547 289.869652,7298.85411 C298.730467,7299.25511 302.015089,7299.03674 303.400182,7295.49028 C303.645956,7294.859 303.815113,7294.1374 303.86188,7293.08031 C304.26686,7284.19677 303.796207,7282.27117 302.251908,7280.72871 C301.027016,7279.50685 299.5862,7278.67508 289.869652,7279.12273 M289.951245,7297.06748 C288.981083,7297.0238 288.454707,7296.86201 288.103459,7296.72603 C287.219865,7296.3826 286.556174,7295.72155 286.214876,7294.84312 C285.623823,7293.32944 285.819846,7286.14023 285.872583,7284.97693 C285.924325,7283.83745 286.155174,7282.79624 286.959165,7281.99226 C287.954203,7280.99968 289.239792,7280.51332 297.993144,7280.90837 C299.135448,7280.95998 300.179243,7281.19026 300.985224,7281.99226 C301.980262,7282.98483 302.473801,7284.28014 302.071806,7292.99991 C302.028024,7293.96767 301.865833,7294.49274 301.729513,7294.84312 C300.829003,7297.15085 298.757333,7297.47145 289.951245,7297.06748 M298.089663,7283.68956 C298.089663,7284.34665 298.623998,7284.88065 299.283709,7284.88065 C299.943419,7284.88065 300.47875,7284.34665 300.47875,7283.68956 C300.47875,7283.03248 299.943419,7282.49847 299.283709,7282.49847 C298.623998,7282.49847 298.089663,7283.03248 298.089663,7283.68956 M288.862673,7288.98792 C288.862673,7291.80286 291.150266,7294.08479 293.972194,7294.08479 C296.794123,7294.08479 299.081716,7291.80286 299.081716,7288.98792 C299.081716,7286.17298 296.794123,7283.89205 293.972194,7283.89205 C291.150266,7283.89205 288.862673,7286.17298 288.862673,7288.98792 M290.655732,7288.98792 C290.655732,7287.16159 292.140329,7285.67967 293.972194,7285.67967 C295.80406,7285.67967 297.288657,7287.16159 297.288657,7288.98792 C297.288657,7290.81525 295.80406,7292.29716 293.972194,7292.29716 C292.140329,7292.29716 290.655732,7290.81525 290.655732,7288.98792"
              id="instagram-[#167]"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const Linkedin = ({ size = 20, fill = "#fff" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill}
  >
    <path d="M22.23 0H1.77C.8 0 0 .77 0 1.72v20.56C0 23.23.8 24 1.77 24h20.46c.98 0 1.77-.77 1.77-1.72V1.72C24 .77 23.2 0 22.23 0zM7.27 20.1H3.65V9.24h3.62V20.1zM5.47 7.76h-.03c-1.22 0-2-.83-2-1.87 0-1.06.8-1.87 2.05-1.87 1.24 0 2 .8 2.02 1.87 0 1.04-.78 1.87-2.05 1.87zM20.34 20.1h-3.63v-5.8c0-1.45-.52-2.45-1.83-2.45-1 0-1.6.67-1.87 1.32-.1.23-.11.55-.11.88v6.05H9.28s.05-9.82 0-10.84h3.63v1.54a3.6 3.6 0 0 1 3.26-1.8c2.39 0 4.18 1.56 4.18 4.89v6.21z" />
  </svg>
);
